'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _autosize = require('autosize');var _autosize2 = _interopRequireDefault(_autosize);

require('./OMTextArea.scss');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var OMTextArea = function (_Component) {_inherits(OMTextArea, _Component);function OMTextArea() {var _temp, _this, _ret;_classCallCheck(this, OMTextArea);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.














    addValue = function (value) {_this.textarea.value = value;}, _temp), _possibleConstructorReturn(_this, _ret);}OMTextArea.prototype.componentDidMount = function componentDidMount() {if (!this.props.isInput) {(0, _autosize2.default)(document.querySelector('#' + this.props.id));if (this.props.initialValue) {this.addValue(this.props.initialValue);}}};OMTextArea.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var initialValue = _ref.initialValue;if (!this.props.isInput && initialValue && initialValue !== this.props.initialValue) {this.addValue(initialValue);}};OMTextArea.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,initialValue = _props.initialValue,isInvalid = _props.isInvalid,isInput = _props.isInput,maxLength = _props.maxLength,restProps = _objectWithoutProperties(_props, ['initialValue', 'isInvalid', 'isInput', 'maxLength']);
    var InputTeg = isInput ? 'input' : 'textarea';

    return (
      _react2.default.createElement(InputTeg, _extends({
        maxLength: maxLength,
        ref: function ref(textarea) {_this2.textarea = textarea;},
        id: this.props.id,
        className: (0, _classnames2.default)('form-control', { not_valid: isInvalid }),
        placeholder: this.props.placeholder },
      restProps)));


  };return OMTextArea;}(_react.Component);


OMTextArea.propTypes = {
  placeholder: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  id: _propTypes2.default.string,
  isInput: _propTypes2.default.bool,
  isInvalid: _propTypes2.default.bool,
  maxLength: _propTypes2.default.number,
  initialValue: _propTypes2.default.string };exports.default =


OMTextArea;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMTextArea/OMTextArea.js
// module id = 562
// module chunks = 0